import React, { useEffect, useState } from "react";
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  ModalCloseButton, Input, Button,
} from "@chakra-ui/react";
import { PALETTES } from "../classroomColors";

const RenameDialog = ({ node, isDark = true, onClose, onSubmit }) => {
  const p = isDark ? PALETTES.dark : PALETTES.light;
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setName(node?.name || "");
  }, [node]);

  const submit = async () => {
    const next = name.trim();
    if (!next || next === node.name) {
      onClose();
      return;
    }
    setSaving(true);
    try {
      await onSubmit(node, next);
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal isOpen={Boolean(node)} onClose={onClose} isCentered size="sm">
      <ModalOverlay bg={p.overlay} backdropFilter="blur(2px)" />
      <ModalContent bg={p.surface} color={p.text} borderRadius="14px" border="1px solid"
        borderColor={p.border} boxShadow="0 24px 60px -20px rgba(0,0,0,0.5)" mx="16px">
        <ModalHeader fontSize="17px" fontWeight="500" pb="6px">Rename</ModalHeader>
        <ModalCloseButton borderRadius="full" color={p.textSub} _hover={{ bg: p.hover }} />
        <ModalBody pb="6px">
          <Input
            autoFocus
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); submit(); } }}
            height="40px" borderRadius="9px" bg={p.inputBg} border="1px solid"
            borderColor={p.inputBorder} color={p.text} fontSize="14px"
            _focus={{ borderColor: p.textMuted, boxShadow: "none" }}
          />
        </ModalBody>
        <ModalFooter gap="8px">
          <Button onClick={onClose} variant="ghost" size="sm" borderRadius="8px"
            color={p.text} _hover={{ bg: p.hover }}>
            Cancel
          </Button>
          <Button onClick={submit} isLoading={saving} size="sm" borderRadius="8px"
            bg={p.solidBg} color={p.solidText} _hover={{ opacity: 0.88 }}>
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RenameDialog;
